/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { Fragment, useState } from "react";
import { Box, Button, Typography } from "@mui/material";

import { useStyles } from "./styles";
import { TITLE } from "./constants";
import Loader from "../../shared/loader/Loader";
import FormDialog from "../../shared/dialog/FormDialog";

interface IDeleteSubEnterpriseDialogProps {
  isOpen: boolean;
  subEnterpriseData?: ISubEnterpriseData;
  onClose: Function;
  deleteSubEnterprise: Function;
}

interface ISubEnterpriseData {
  id: string;
  name: string;
}

export interface IErrorObj {
  error?: boolean;
  errorHelperText?: string;
}

const DeleteSubEnterpriseDialog = (props: IDeleteSubEnterpriseDialogProps) => {
  const classes = useStyles();

  const [showLoader, showHideLoader] = useState(false);

  const handleClose = () => {
    props.onClose(!props.isOpen);
  };

  const handleSubmit = async () => {
    props.deleteSubEnterprise()
  };

  return (
    <Fragment>
      <FormDialog
        dialogAction1={
          <Button
            color="primary"
            disableElevation
            name="cancelBtn"
            onClick={handleClose}
            variant="outlined"
          >
            {TITLE.CANCEL}
          </Button>
        }
        dialogAction2={
          <Button
            color="error"
            disableElevation
            disabled={showLoader}
            name="createCustomerBtn"
            onClick={handleSubmit}
            variant="contained"
          >
            {TITLE.DELETE}
          </Button>
        }
        dialogTitle={TITLE.DELETE_SUB_ENTERPRISE}
        handleClose={handleClose}
        openModal={props.isOpen}
      >
        <Box className={classes.modalFormContent}>
          <Box>
            {TITLE.DELETE_SUB_ENTERPRISE_MESSAGE}
            <Typography
              component="span"
              variant="body1"
              style={{ fontWeight: "bold" }}
            >
              {props.subEnterpriseData?.name}
            </Typography>
            {TITLE.THIS_ACTION_CANNOT_BE_UNDONE}
          </Box>
        </Box>
        <Loader showLoader={showLoader} isCenter />
      </FormDialog>
    </Fragment>
  );
};

export default DeleteSubEnterpriseDialog;
